import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable, throwError } from 'rxjs';
import { CrudService } from "./crud.service";
import { GenericResponse, Gremio, SearchGremioRequest, SearchGremioResponse, SaveGremioDto } from "../model/index";
import { SharedFunctions } from '../shared.functions';

@Injectable({
  providedIn: 'root'
})
export class GremioService extends CrudService<Gremio, number, SaveGremioDto, SearchGremioRequest> {

  constructor(protected _http: HttpClient, protected sharedFunctions: SharedFunctions) {
    super(_http,'Gremio', sharedFunctions);

  }

  getAll(): Observable<GenericResponse<Gremio[]>> {
    return this._http.get<GenericResponse<Gremio[]>>(this._serviceUrl + '', this.httpOptions);
  }

  
}